import { api } from "@/api";

export async function getCommonConfig(): Promise<any> {
  const res = await api.commonConfig();
  return res;
}

export async function updateCommonConfig(payload: {
  LogoutTime: number;
  WarningTime: number;
  InactiveDays: number;
    TourIcon: boolean;
    NotificationIcon: boolean;
    LanguageSwitchIcon: boolean;
}): Promise<any> {
  const res = await api.commonConfigUpdate(payload);
  return res;
}